import libJwt from 'jsonwebtoken'

export const AUTHENTICATION_TOKEN = 'authenticationToken'
export const REFRESH_TOKEN = 'refreshToken'

class AuthenticationProvider {
  static getToken() {
    return sessionStorage.getItem(AUTHENTICATION_TOKEN) || localStorage.getItem(AUTHENTICATION_TOKEN)
  }

  static getRefreshToken() {
    return sessionStorage.getItem(REFRESH_TOKEN) || localStorage.getItem(REFRESH_TOKEN)
  }

  static setToken(jws) {
    if (jws === null) {
      return
    }

    sessionStorage.setItem(AUTHENTICATION_TOKEN, jws)
    localStorage.setItem(AUTHENTICATION_TOKEN, jws)
  }

  static setRefreshToken(jws) {
    if (jws === null) {
      return
    }

    sessionStorage.setItem(REFRESH_TOKEN, jws)
    localStorage.setItem(REFRESH_TOKEN, jws)
  }

  static clearTokens() {
    sessionStorage.removeItem(AUTHENTICATION_TOKEN)
    localStorage.removeItem(AUTHENTICATION_TOKEN)
    sessionStorage.removeItem(REFRESH_TOKEN)
    localStorage.removeItem(REFRESH_TOKEN)
  }

  static getJwsPayload() {
    const jws = AuthenticationProvider.getToken()
    if (!jws) {
      return null
    }
    return libJwt.decode(jws)
  }

  // exp: 1599575831
  // iat: 1599574931
  // iss: "projectferro.com"
  // jti: "c2b31e7f-06ab-4d1b-9bfe-f713ee5c1a86"
  // sub: "alex"
  static getClaims() {
    const jwsPayload = AuthenticationProvider.getJwsPayload()
    if (!jwsPayload) {
      return null
    }

    return jwsPayload
  }

  static isCurrentTokenExpired() {
    const jwsPayload = AuthenticationProvider.getJwsPayload()
    return this.isExpired(jwsPayload)
  }

  static isExpired(jwsPayload) {
    const now = Math.floor(Date.now() / 1000)
    const expiresAt = jwsPayload.exp

    if (now > expiresAt) {
      return true
    }
    return false
  }

  // static authenticate (creds) {
  //   return HttpClient.post('auth/login', creds)
  //     .then((response) => {
  //       if (response.status === 200 && response.data.token) {
  //         const token = response.data.token
  //         AuthenticationProvider.setToken(token)
  //         AuthenticationProvider.setRefreshToken(response.data.refresher)
  //       }
  //       return response;
  //     })
  //     .catch((error) => {
  //       return error;
  //       // Do nothing
  //     })
  // }

  // static refreshToken () {
  //   const refresh = AuthenticationProvider.getRefreshToken()
  //   const request = {
  //     refreshToken: `Bearer ${refresh}`
  //   }
  //
  //   HttpClient.post('auth/refresh', request)
  //     .then((response) => {
  //       if (response.status === 200 && response.data.token) {
  //         const token = response.data.token
  //         AuthenticationProvider.setToken(token)
  //         AuthenticationProvider.setRefreshToken(response.data.refresher)
  //       }
  //       return response;
  //     })
  //     .catch(() => {
  //       return false
  //     })
  // }
  //
  // static setTokens (token, refreshToken) {
  //   AuthenticationProvider.setToken(token)
  //   AuthenticationProvider.setRefreshToken(refreshToken)
  // }
}

export default AuthenticationProvider
